<form #filterForm="ngForm" class="mb-3">
    <div class="row">
        <div class="col-sm-6 col-lg">
            <div class="form-field">
                <app-date name="filterDateFrom"
                          [(ngModel)]="filterValues.dateFrom"
                          [placeholder]="'healthMinistryDashboard_lblPeriodFrom' | translate"
                          [max]="filterValues.dateTo"
                          (dateChange)="filter()"></app-date>
            </div>
        </div>

        <div class="col-sm-6 col-lg">
            <div class="form-field">
                <app-date name="filterDateTo"
                          [(ngModel)]="filterValues.dateTo"
                          [placeholder]="'healthMinistryDashboard_lblPeriodTo' | translate"
                          [min]="filterValues.dateFrom"
                          (dateChange)="filter()"></app-date>
            </div>
        </div>

        <div class="col-sm-6 col-md-4 col-lg">
            <div class="form-field">
                <app-select name="filterStatus"
                            [options]="filters.status"
                            [placeholder]="'healthMinistryDashboard_lblStatus' | translate"
                            [(ngModel)]="filterValues.status"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>

        <div class="col-sm-6 col-md-4 col-lg">
            <div class="form-field">
                <app-select name="filterStudyYear"
                            [options]="filters.studyYear"
                            [placeholder]="'healthMinistryDashboard_lblStudyYear' | translate"
                            [(ngModel)]="filterValues.studyYear"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>

        <div class="col-md-4 col-lg">
            <div class="form-field">
                <app-select name="filterSpeciality"
                            [options]="filters.speciality"
                            [placeholder]="'healthMinistryDashboard_lblSpeciality' | translate"
                            [(ngModel)]="filterValues.speciality"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12 col-lg">
            <div class="form-field">
                <input class="form-control"
                       [placeholder]="'healthMinistryDashboard_lblNameSurnameId' | translate"
                       [(ngModel)]="filterValues.search"
                       name="filterSearch"
                       (input)="filter(true)" />
            </div>
        </div>

        <div class="col-sm-6 col-lg">
            <div class="form-field">
                <app-select name="filterWorkplace"
                            [options]="filters.workplace"
                            [placeholder]="'healthMinistryDashboard_lblWorkplace' | translate"
                            [(ngModel)]="filterValues.workplace"
                            [filter]="true"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>

        <div class="col-sm-6 col-lg">
            <div class="form-field">
                <app-select name="filterClinicalBase"
                            [options]="filters.clinicalBase"
                            [placeholder]="'healthMinistryDashboard_lblClinicalBase' | translate"
                            [(ngModel)]="filterValues.clinicalBase"
                            [filter]="true"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>

        <div class="col-sm-6 col-md-6 col-lg">
            <div class="form-field">
                <app-select name="filterStudyType"
                            [options]="filters.studyType"
                            [placeholder]="'healthMinistryDashboard_lblFinancing' | translate"
                            [(ngModel)]="filterValues.studyType"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>

        <div class="col-sm-6 col-md-6 col-lg">
            <div class="form-field">
                <app-select name="filterFinanceType"
                            [options]="filters.financeType"
                            [placeholder]="'healthMinistryDashboard_lblFinancingType' | translate"
                            [(ngModel)]="filterValues.financeType"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>
    </div>

    <div class="toolbar-buttons">
        <button class="btn btn-outline" (click)="clearFilter()">
            <i class="fi fi-rs-cross"></i>
            {{'healthMinistryDashboard_btnClearFilter' | translate}}
        </button>

        <button class="btn btn-secondary" (click)="export()" [disabled]="!rows.length">
            <i class="fi fi-rs-download"></i>
            {{'healthMinistryDashboard_btnExport' | translate}}
        </button>
    </div>
</form>

<app-table [rows]="rows"
           [columns]="columns"
           [pageSize]="pageSize"
           [page]="page"
           [sortBy]="sortBy"
           [sortDir]="sortDir"
           [sticky]="'left'"
           (pageChange)="onPage($event)"
           (sortChange)="onSort($event)">
    <ng-template #rowTemplate let-row>
        <tr>
            <td>
                <div>
                    <a [routerLink]="['/health-ministry-dashboard/residents', row.StudentId] | localize">
                        {{row.Name}} {{row.Surname}}
                    </a>
                </div>
                <div class="text-sub text-nowrap">({{row.CertNumber}})</div>
            </td>
            <td>{{row.StudyProgramName}}</td>
            <td>
                <app-health-ministry-resident-status [id]="row.StudentStatusId"
                                                     [name]="row.StudentStatusName">
                </app-health-ministry-resident-status>
            </td>
            <td>{{row.StudyYear}}</td>
            <td>{{row.StudyBeginDate | appDate}}</td>
            <td>{{row.StudyPlannedEndDate | appDate}}</td>
            <td>{{row.WorkplaceName}}</td>
            <td>{{row.ClinicalBaseName}}</td>
            <td>{{row.StudyTypeName}}</td>
            <td>{{row.StudyFinanceTypeName}}</td>
        </tr>
    </ng-template>
</app-table>
